import React from 'react';
import NoPermissionError from './NoPermissionError';

export default (props) => {
  const { title } = props;
  return (
    <NoPermissionError
      title={title}
      text={i18n('Timesheets are not used by your team.')}
    />
  );
};
